import { Component } from '@angular/core';
import { LoadingController,App} from 'ionic-angular';
import { HttpService } from '../../../../providers/service/httpservice';
import { BrowserPage } from '../../../comm/browser/browser';
import { NewsDetail } from '../detail/detail';
import { AppState } from '../../../../app/app.global';
import { StorageService } from '../../../../providers/service/storageservice';
import { NEWS_TYPES,NEWS_BY_TYPE} from '../../../../providers/config/serviceurl';
import { Utils} from '../../../../providers/service/utils';

@Component({
  selector: 'news-list-page',
  templateUrl: 'list.html'
})
export class NewsListPage {
	infiniteSscroll:any=null;//上拉控件
  overFlag:boolean = false;//数据全部加载完成标志
	newsTypes:any[] = [];//新闻类型
	pageNo:number = 0;//分页页数
	news:any = [];//新闻列表
	pageSize:number = 8;
	typeId = "";//记录新闻类型
	pageSlides:any[]=[];//显示页面
	public loading:any;
	user:any={};
	resourceUrl:any;//资源url；
	constructor (private loadCtrl:LoadingController,public appCtrl: App,
		public global: AppState,private httpService:HttpService) {
		this.user = StorageService.getObj('currentUser');
		this.resourceUrl = StorageService.getObj('resourceUrl');
    this.getNewsTypes();
	}
	getNewsTypes(){
		/*this.newsTypes = [
			{ "id": 100162, "name": "树维新闻", badgeNum:"0"},
			{ "id": 10001, "name": "通知公告" ,badgeNum:"0"}];

			console.log(this.newsTypes);
			this.pageSlides = this.newsTypes;
			this.global.slidesShow = this.newsTypes;
			console.log(this.pageSlides);
			console.log(this.global.slidesShow);
		for(let i=0;i<this.newsTypes.length;i++){
  			this.pageSlides.push(this.newsTypes[i]);
		}*/
		// this.httpService.get(NEWS_TYPES,null).then(anyObj =>this.handNewsTypes(anyObj));
		let params = {"username":this.user.xgh};
		this.httpService.get2(NEWS_TYPES,params).then(anyObj =>this.handNewsTypes(anyObj));

	}

	handNewsTypes(obj){
		console.dir(obj);
		if(obj.items){
			let types = obj.items;
			for(let i=0;i<types.length;i++){
				let type = {'id':types[i].id,"name":types[i].columnName,badgeNum:"0"};
				this.newsTypes.push(type);
			}

			this.pageSlides = this.newsTypes;
			//this.global.slidesShow = this.newsTypes;

			if(this.newsTypes.length > 0){
				this.onSlideClick(0);
			}

		}
	}

	//触发my-slider  组件滑动事件  一些属性数据需要重置
  onSlideClick(index:any) {
    this.loading = this.loadCtrl.create({
      content: '加载中...',
    });
    this.loading.present();
    this.pageNo = 0;
    this.typeId = this.newsTypes[index].id;
    this.getNewsList(this.typeId,"refresh");
  }
  getNewsList(type:string,oType:string){
			var params = {'pageNo':this.pageNo,
										'pageSize':this.pageSize,
										// 'loadAll':false,
										'username':this.user.xgh,
									  'columnId':type
									 };
									 console.dir(params);
			this.httpService.get2(NEWS_BY_TYPE,params).then(anyObj =>this.handleNewsList(anyObj));
  		if(oType == "refresh"){
        this.pageNo=0;
  			this.news = [];
  		}
  }
  handleNewsList(obj:any){
		// obj = JSON.parse(obj);
		// this.pageNo=0;
		// this.news = [];
  	if(obj&&obj!=null&&obj.items!=null){
  		var length = obj.items.length;
  		for(var i=0;i<length;i++){
				// if(obj.items[i].releaseDate !=undefined && obj.items[i].releaseDate !=null && obj.items[i].releaseDate !=""){
				// 	obj.items[i].releaseDate = Utils.formateTimeGap((new Date(obj.items[i].releaseDate)).getTime());
				// }
  			this.news.push(obj.items[i]);
  		}
		}
		if(obj != null){
			this.disableInfiniteSscroll(obj.items);
		}else{
			this.disableInfiniteSscroll(null);
		}

  	this.loading.dismiss();//加载动画结束
  }
  //上拉加载
  loadMore(refresher:any){
		if(this.infiniteSscroll == null){
      this.infiniteSscroll = refresher;
    }
  	setTimeout(() => {
			this.pageNo++;
      this.getNewArticle(this.typeId);
      refresher.complete();
    }, 500);
  }
  //下拉刷新
  doRefresh(refresher){
  	setTimeout(() => {
			this.pageNo=0;
			this.news = [];
      this.getNewArticle(this.typeId);
      refresher.complete();
    }, 1000);
  }
  //加载新的数据
  getNewArticle(type:string) {
    this.getNewsList(type,"add");
  }
  showNewsDetail(event:any,item:any) {
  	if(item!=null&&item!='undefined'&&item!=''
  		&&item.link!=null&&item.link!='undefined'&&item.link!=''){
  		this.appCtrl.getRootNav().push(BrowserPage,{
						browser: {title: item.title, url: item.link}});
						window.open(item.link);
  	}else{
  		this.appCtrl.getRootNav().push(NewsDetail,item);
  	}
	}

	//数据全部加载完，取消上拉功能，并显示“这是我的底线提示”
  disableInfiniteSscroll(items:any){
    if(this.infiniteSscroll != null){
      if(items == null || items == undefined || items.length == 0){
        this.overFlag = true;
        this.infiniteSscroll.enable(false);
      }else{
        this.overFlag = false;
        this.infiniteSscroll.enable(true);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/news/list/list.ts